<!-- RESPONSIVE DOCUMENT EDITOR TEMPLATE -->
<div fxLayout="column" fxFlexFill class="doc-root" [class.quill-fullscreen-active]="quillFullscreen"
    [class.onlyoffice-tab-fullscreen-active]="onlyOfficeFullscreenMode === 'tab'" #resizable>

    <!-- ---------- ACTION BAR (desktop) ---------- -->
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px" fxHide.lt-md class="action-bar">
        <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
            <button *ngIf="document.id" mat-icon-button (click)="repeatDocument()" title="Repetir documento"
                color="accent" [disabled]="isButtonDisabled">
                <mat-icon>repeat</mat-icon>
            </button>

            <button *ngIf="document.id" mat-icon-button (click)="printItem($event, document)" title="Imprimir documento"
                color="accent" [disabled]="isButtonDisabled"> <mat-icon>print</mat-icon> </button>

            <button *ngIf="document.id && document.signed" mat-icon-button (click)="sendEmailPdf($event, document)"
                title="Enviar por email" color="accent" [disabled]="isButtonDisabled"> <mat-icon>email</mat-icon>
            </button>

            <button *ngIf="document.id" mat-icon-button (click)="saveDocumentOnlyOffice()" title="Salvar" color="accent"
                [disabled]="isButtonDisabled"> <mat-icon>save</mat-icon> </button>

            <button *ngIf="!pdfHistory" mat-icon-button (click)="generateReportFHD(data.patient.id)"
                title="Historico de Anamneses" color="accent">
                <mat-icon>history</mat-icon>
            </button>

            <button *ngIf="!pdfHistory" mat-icon-button (click)="printHistory(data.patient.id)"
                title="Historico Completo" color="accent" [disabled]="isButtonDisabled">
                <mat-icon>receipt</mat-icon>
            </button>

            <button mat-icon-button (click)="openAttachment()" title="Visualizar Anexos" color="accent"
                [disabled]="isButtonDisabled">
                <mat-icon>attach_file</mat-icon>
            </button>

            <button *ngIf="pdfHistory" mat-icon-button (click)="hideReport()" title="Ocultar Historico" color="accent">
                <mat-icon>close</mat-icon>
            </button>

            <button *ngIf="document.id" mat-icon-button (click)="openCapture()" title="Captura" color="accent">
                <mat-icon>add_a_photo</mat-icon>
            </button>

            <button *ngIf="document.id" mat-icon-button [disabled]="isButtonDisabled" (click)="openExpression()"
                title="Formulas" color="accent">
                <mat-icon>functions</mat-icon>
            </button>

            <button *ngIf="document.id" mat-icon-button color="accent" [disabled]="isButtonDisabled"
                (click)="newDocument()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>

    <!-- ---------- ACTION BAR (mobile / small) - condensed ---------- -->
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="4px" fxHide.gt-sm class="action-bar-mobile">
        <mat-menu #mobileActions="matMenu">
            <button *ngIf="document.id" mat-menu-item (click)="saveDocumentOnlyOffice()" [disabled]="isButtonDisabled">
                <mat-icon>save</mat-icon>
                <span>Salvar</span>
            </button>
            <button *ngIf="document.id && document.signed" mat-menu-item (click)="sendEmailPdf($event, document)"
                [disabled]="isButtonDisabled">
                <mat-icon>email</mat-icon>
                <span>Enviar por email</span>
            </button>
            <button mat-menu-item (click)="openAttachment()" [disabled]="isButtonDisabled">
                <mat-icon>attach_file</mat-icon>
                <span>Anexos</span>
            </button>
            <button *ngIf="document.id" mat-menu-item (click)="openCapture()">
                <mat-icon>add_a_photo</mat-icon>
                <span>Captura</span>
            </button>
            <button *ngIf="document.id" mat-menu-item (click)="openExpression()" [disabled]="isButtonDisabled">
                <mat-icon>functions</mat-icon>
                <span>Fórmulas</span>
            </button>
            <button *ngIf="document.id" mat-menu-item (click)="newDocument()" [disabled]="isButtonDisabled">
                <mat-icon>add</mat-icon>
                <span>Novo</span>
            </button>
            <button *ngIf="!pdfHistory" mat-menu-item (click)="generateReportFHD(data.patient.id)">
                <mat-icon>history</mat-icon>
                <span>Histórico de anamneses</span>
            </button>
            <button *ngIf="!pdfHistory" mat-menu-item (click)="printHistory(data.patient.id)"
                [disabled]="isButtonDisabled">
                <mat-icon>receipt</mat-icon>
                <span>Histórico completo</span>
            </button>
            <button fxHide.gt-sm mat-menu-item (click)="togglePatientInfoMobile()">
                <mat-icon>person</mat-icon>
                <span>Informações do paciente</span>
            </button>
            <button *ngIf="pdfHistory" mat-menu-item (click)="hideReport()">
                <mat-icon>close</mat-icon>
                <span>Ocultar histórico</span>
            </button>
        </mat-menu>

        <span class="mobile-view-chip" *ngIf="!toggleHistory && !pdfHistory">{{ data.nameDocument }}</span>
        <span class="mobile-view-chip" *ngIf="toggleHistory && !pdfHistory">Histórico</span>
        <span class="mobile-view-chip" *ngIf="pdfHistory">Histórico completo</span>

    </div>

    <div class="mobile-spacer"></div>

    <div fxHide.gt-sm class="mobile-patient-info" *ngIf="showPatientInfoMobile">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="mobile-patient-info-header">
            <strong>Paciente</strong>
            <button mat-icon-button type="button" (click)="togglePatientInfoMobile()" title="Fechar informações">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="mobile-patient-info-grid">
            <p><b>Nome:</b> {{ data.patient?.person?.name || data.patient?.name || '---' }}</p>
            <p><b>Sexo:</b> {{ data.patient?.person?.gender?.name || '---' }}</p>
            <p><b>Nascimento:</b> {{ data.patient?.person?.birthday ? (data.patient.person.birthday | date :
                'dd/MM/yyyy') : '---' }}</p>
            <p><b>Idade:</b> {{ data.patient?.person?.age || '---' }}</p>
            <p><b>Convênio:</b> {{ data.patient?.insurance?.name || '---' }}</p>
            <p><b>CNS:</b> {{ data.patient?.person?.cns || '---' }}</p>
            <p><b>Tel/Cel:</b> {{ data.patient?.person?.phoneStandart || '---' }}</p>
            <p><b>E-mail:</b> {{ data.patient?.person?.emailStandart || '---' }}</p>
            <p><b>Profissional:</b> {{ data.performer?.professional?.person?.name || '---' }}</p>
        </div>
    </div>

    <!-- ---------- MAIN AREA ---------- -->
    <div fxLayout="row" fxFlexFill class="content-area" [class.mobile-history-open]="toggleHistory && !pdfHistory"
        [class.mobile-pdf-history-open]="pdfHistory" style="min-height: 0;">

        <div *ngIf="document.signed && pdfSrc == null && (!isMobileView() || (!toggleHistory && !pdfHistory))"
            fxFlex="1 1 100%"
            [fxFlex.gt-sm]="toggleHistory ? '65%' : '100%'" fxLayout="column"
            class="left-panel signed-pdf-panel"
            [class.mobile-hidden-when-history]="(toggleHistory && !pdfHistory) || pdfHistory">
            <div *ngIf="signatureValidationLoading" class="signature-status loading">
                <mat-icon>hourglass_empty</mat-icon>
                <span>Validando assinatura digital...</span>
            </div>

            <div *ngIf="!signatureValidationLoading && signatureValidation?.valid" class="signature-status valid">
                <mat-icon>verified_user</mat-icon>
                <span>Assinatura digital verificada pelo sistema. Validação oficial:
                    <a href="https://validar.iti.gov.br/" target="_blank">validar.iti.gov.br</a>
                </span>
            </div>

            <div *ngIf="!signatureValidationLoading && signatureValidation && !signatureValidation.valid"
                class="signature-status invalid">
                <mat-icon>error_outline</mat-icon>
                <span>Assinatura digital não validada. O envio por e-mail fica bloqueado.
                    <a href="https://validar.iti.gov.br/" target="_blank">Validar no ITI</a>
                </span>
                <button mat-stroked-button color="warn" type="button" (click)="resignDocument($event, document)"
                    [disabled]="isButtonDisabled">
                    <mat-icon>edit</mat-icon>
                    Refazer assinatura
                </button>
            </div>

            <ngx-extended-pdf-viewer [base64Src]="document.signed" [showHandToolButton]="true" [handTool]="false"
                [showUnverifiedSignatures]="false" [contextMenuAllowed]="false" [showSidebarButton]="false"
                height="100%" [zoom]="zoom" fxFlex="1 1 100%" fxLayout="column">
            </ngx-extended-pdf-viewer>
        </div>

        <!-- LEFT PANEL: editor + controls
         - full width on xs/sm
         - ~65% on md+ -->
        <div *ngIf="!document.signed && (!isMobileView() || (!toggleHistory && !pdfHistory))" fxFlex="1 1 100%"
            [fxFlex.gt-sm]="toggleHistory ? '65%' : '100%'"
            fxLayout="column" class="left-panel"
            [class.onlyoffice-document-active]="document.format == 'docx' || document.format == 'rtf'"
            [class.mobile-hidden-when-history]="(toggleHistory && !pdfHistory) || pdfHistory">

            <!-- Filters row (wraps on small screens) -->
            <div fxLayout="row wrap" fxLayoutAlign="start center" class="filters-row" style="margin-bottom: -15px;">
                <mat-form-field fxFlex="1 1 320px" appearance="outline" *ngIf="!document.id">
                    <mat-label>Modelos de {{data.nameDocument}}</mat-label>
                    <input matInput [matAutocomplete]="autoModels" [formControl]="modelsControl" placeholder="Modelo"
                        type="search" [disabled]="document.id">
                    <mat-autocomplete #autoModels="matAutocomplete" [displayWith]="displayFn">
                        <mat-option *ngFor="let model of modelsList" [value]="model" [title]="model.title">
                            {{model.title}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field fxFlex="1 1 240px" appearance="outline">
                    <mat-label>Especialidade</mat-label>
                    <input matInput type="search" autocomplete="off" [matAutocomplete]="auto"
                        [formControl]="specialityControl" placeholder="Nome">
                    <mat-error *ngIf="specialityControl.hasError('incorrect')">Especialidade inválida</mat-error>
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayGenericFn"
                        (optionSelected)="setSpeciality($event.option.value)">
                        <mat-option *ngFor="let speciality of specialityList" [value]="speciality">
                            {{speciality?.name}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <!-- CIDs (aparece quando document.id existe) -->
            <div *ngIf="document.id" fxLayout="row" fxLayoutAlign="start center" class="cid-row"
                style="margin-bottom: -15px;">
                <mat-form-field fxFlex appearance="outline">
                    <mat-label>Cids</mat-label>
                    <mat-chip-list #chipList aria-label="Cid selection">
                        <mat-chip [ngStyle]=" cid.main ? {'background-color':'#00bcd4'}: ''"
                            *ngFor="let cid of cidListSelected" (removed)="cidRemove(cid)" (dblclick)="cidMain(cid)">
                            {{cid.cid.name}} | {{cid.cid.code}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input placeholder="Selecione..." #cidInput [formControl]="cidFormControl"
                            [matAutocomplete]="autoCid" [matChipInputFor]="chipList">
                    </mat-chip-list>
                    <mat-autocomplete #autoCid="matAutocomplete" (optionSelected)="cidSelected($event)">
                        <mat-option *ngFor="let cid of CIDList" [value]="cid">
                            {{cid.name}} | {{cid.code}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <!-- Editor area: ONLYOFFICE OR QUILL -->
            <div fxFlex fxLayout="column" class="editor-wrapper" [class.quill-fullscreen-wrapper]="quillFullscreen"
                style="min-height: 0; margin-bottom: 0px;">
                <!-- ONLYOFFICE -->
                <div #onlyOfficeShell fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="8px"
                    class="onlyoffice-editor-shell"
                    [class.onlyoffice-tab-fullscreen-wrapper]="onlyOfficeFullscreenMode === 'tab'"
                    [class.onlyoffice-fullscreen-wrapper]="onlyOfficeFullscreenMode === 'screen'"
                    *ngIf="document.format == 'docx' || document.format == 'rtf'" style="width: 100%; height: 100%;">
                    <div class="onlyoffice-expand-actions">
                        <button mat-icon-button type="button" class="onlyoffice-fullscreen-button"
                            (click)="toggleOnlyOfficeTabFullscreen($event)"
                            [title]="onlyOfficeFullscreenMode === 'tab' ? 'Voltar ao normal' : 'Expandir na aba'">
                            <mat-icon>{{ onlyOfficeFullscreenMode === 'tab' ? 'fullscreen_exit' : 'aspect_ratio'
                                }}</mat-icon>
                        </button>

                        <button mat-icon-button type="button" class="onlyoffice-fullscreen-button"
                            (click)="toggleOnlyOfficeScreenFullscreen($event)"
                            [title]="onlyOfficeFullscreenMode === 'screen' ? 'Voltar ao normal' : 'Tela cheia'">
                            <mat-icon>{{ onlyOfficeFullscreenMode === 'screen' ? 'fullscreen_exit' : 'fullscreen'
                                }}</mat-icon>
                        </button>
                    </div>

                    <div class="onlyoffice-floating-actions" *ngIf="onlyOfficeFullscreenMode">
                        <button *ngIf="document.id" mat-icon-button type="button" class="onlyoffice-action-button"
                            (click)="saveDocumentOnlyOffice()" title="Salvar" [disabled]="isButtonDisabled">
                            <mat-icon>save</mat-icon>
                        </button>

                        <button *ngIf="document.id" mat-icon-button type="button" class="onlyoffice-action-button"
                            (click)="printItem($event, document)" title="Imprimir" [disabled]="isButtonDisabled">
                            <mat-icon>print</mat-icon>
                        </button>

                        <button mat-icon-button type="button" class="onlyoffice-action-button" (click)="openAttachment()"
                            title="Anexos" [disabled]="isButtonDisabled">
                            <mat-icon>attach_file</mat-icon>
                        </button>

                        <button *ngIf="document.id" mat-icon-button type="button" class="onlyoffice-action-button"
                            (click)="openCapture()" title="Captura">
                            <mat-icon>add_a_photo</mat-icon>
                        </button>

                        <button *ngIf="document.id" mat-icon-button type="button" class="onlyoffice-action-button"
                            [disabled]="isButtonDisabled" (click)="openExpression()" title="Fórmulas">
                            <mat-icon>functions</mat-icon>
                        </button>

                        <button *ngIf="document.id" mat-icon-button type="button" class="onlyoffice-action-button"
                            [disabled]="isButtonDisabled" (click)="newDocument()" title="Novo">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>

                    <div fxFlex class="onlyoffice-editor-container" style="min-height: 0; width: 100%; height: 100%;">
                        <!-- mostrar onlyoffice quando aplicável -->
                        <div *ngIf="document.format == 'docx' || document.format == 'rtf'" id="docx"></div>
                    </div>
                </div>

                <!-- QUILL -->
                <div fxFlex class="quill-editor-shell"
                    style="display: flex; flex-direction: column; min-height: 0; height: 100%;"
                    *ngIf="document.format != 'docx' && document.format != 'rtf'">
                    <button mat-icon-button type="button" class="quill-fullscreen-button"
                        (click)="toggleQuillFullscreen($event)"
                        [title]="quillFullscreen ? 'Voltar ao normal' : 'Expandir editor'">
                        <mat-icon>{{ quillFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
                    </button>

                    <quill-editor #quill id="quill" class="editor" [modules]="configEditor" [formControl]="documentForm"
                        format="html" [placeholder]="data.nameDocument" (onEditorCreated)="onEditorCreated($event)">
                    </quill-editor>
                </div>

            </div>

            <!-- ACTION BUTTONS (row wraps on small) -->
            <div fxLayout="row wrap" fxLayoutGap="8px" fxLayoutAlign="center center" class="action-row">
                <button mat-raised-button color="warn" (click)="closeModal()" id="evolutionClosebT">
                    <mat-icon>close</mat-icon> Cancelar
                </button>

                <button mat-raised-button color="primary" *ngIf="document.format != 'docx'"
                    [disabled]="isButtonDisabled" (click)="insert('html',null)">
                    <mat-icon>save</mat-icon> Salvar
                </button>

                <button fxHide.gt-sm mat-raised-button color="accent"
                    *ngIf="document.id && (document.format == 'docx' || document.format == 'rtf')"
                    [disabled]="isButtonDisabled" (click)="printItem($event, document)">
                    <mat-icon>print</mat-icon> Imprimir
                </button>

                <button *ngIf="document.id" mat-raised-button color="accent" [disabled]="isButtonDisabled"
                    (click)="newDocument()">
                    <mat-icon>add</mat-icon> Novo
                </button>

                <button mat-raised-button style="background-color: #4ac529; color: white;"
                    *ngIf="document.id && checkProfessional(document.performer?.id)"
                    (click)="signDocument($event,document)" [disabled]="isButtonDisabled || signingDocument">
                    <img src="assets/icons/signature_white.svg" alt="Assinar" style="height:18px; margin-right:6px;">
                    Assinar
                </button>

                <button fxHide.gt-sm mat-raised-button color="accent" (click)="toggleHistoryPatient()">
                    <mat-icon>history</mat-icon> Histórico
                </button>

                <button fxHide.gt-sm mat-raised-button color="accent" [matMenuTriggerFor]="mobileActions">
                    <mat-icon>more_vert</mat-icon> Mais
                </button>
            </div>

        </div> <!-- end left-panel -->

        <!-- TOGGLE BUTTON (small column between panels) -->
        <div fxFlex="none" fxLayout="row" fxLayoutAlign="center center" class="toggle-column"
            [style.alignSelf]="'start'">
            <div *ngIf="!pdfHistory">
                <button mat-icon-button (click)="toggleHistoryPatient()" color="accent" aria-label="toggle history">
                    <mat-icon *ngIf="!toggleHistory" title="Exibir Historico">chevron_left</mat-icon>
                    <mat-icon *ngIf="toggleHistory" title="Ocultar Historico">navigate_next</mat-icon>
                </button>
            </div>
        </div>

        <!-- RIGHT PANEL: history accordion
         - full width under certain breakpoints
         - ~35% on gt-sm -->
        <div fxFlex="1 1 100%" [fxFlex.gt-sm]="sliderValue" fxLayout="column" class="right-panel"
            *ngIf="toggleHistory && !pdfHistory" style="min-height: 0;">

            <!-- slider centered -->
            <div fxLayout="row" fxLayoutAlign="center center" class="history-slider">
                <mat-slider thumbLabel [displayWith]="formatLabel" tickInterval="10" step="10" min="30" max="100"
                    [(ngModel)]="sliderValue" aria-label="units"></mat-slider>
            </div>

            <!-- optional image -->
            <div *ngIf="imagePath" fxLayout="row" fxLayoutAlign="center center" class="history-profile">
                <img [src]="imagePath" class="profile-image" />
            </div>

            <div fxLayout="row" fxLayoutAlign="center center" class="history-title">
                <h1 mat-dialog-title>Historico de {{data.nameDocument}}</h1>
            </div>

            <div fxHide.gt-sm fxLayout="row" fxLayoutAlign="space-between center" class="history-mobile-header">
                <span>Histórico</span>

                <div fxLayout="row" fxLayoutAlign="end center">
                    <button *ngIf="selectedDocuments.length > 0" mat-icon-button (click)="printDocumentsList()"
                        title="Imprimir selecionados" color="accent" [disabled]="isButtonDisabled">
                        <mat-icon>print</mat-icon>
                    </button>

                    <button mat-icon-button (click)="returnToAnamnese()" title="Voltar para anamnese" color="accent">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                </div>
            </div>

            <button *ngIf="selectedDocuments.length > 0" mat-icon-button class="history-print-desktop"
                (click)="printDocumentsList()" title="Imprimir documentos" color="accent" [disabled]="isButtonDisabled">
                <mat-icon>print</mat-icon>
            </button>

            <!-- WRAPPER WITH SCROLL (important: min-height:0 on parents) -->
            <div fxFlex style="min-height: 0; overflow-y: auto; overflow-x: hidden;" class="panel-wrapper">
                <mat-accordion>
                    <mat-expansion-panel class="expasion-documents"
                        *ngFor="let document of data.documentList; let i = index" (opened)="openPanel(document, i)"
                        (closed)="closedPanel(document)">
                        <mat-expansion-panel-header class="document-panel-header">
                            <mat-panel-title class="document-title">

                                <mat-checkbox class="document-checkbox" color="accent"
                                    [checked]="isDocumentSelected(document)" (click)="$event.stopPropagation()"
                                    (change)="toggleDocumentSelection(document, $event.checked)">
                                </mat-checkbox>

                                <div class="document-info">
                                    <img *ngIf="document.signed" class="document-icon"
                                        title="Documento assinado com certificado digital" src="assets/icons/sign.svg"
                                        alt="signed">

                                    <mat-icon *ngIf="!document.signed" class="document-icon">
                                        today
                                    </mat-icon>

                                    <b class="document-date">
                                        {{ document.dateAt == null ? '---' : (document.dateAt | date: 'dd/MM/yyyy') }}
                                    </b>
                                </div>

                            </mat-panel-title>

                            <div class="document-actions">
                                <button *ngIf="document.signed" mat-icon-button color="accent" title="Enviar por email"
                                    (click)="sendEmailPdf($event, document)">
                                    <mat-icon>mail</mat-icon>
                                </button>

                                <button mat-icon-button color="accent" title="Visualizar"
                                    (click)="viewDocument($event, document)"
                                    [disabled]="document.editing == false || document.performer?.id !== data.performer?.id">
                                    <mat-icon>search</mat-icon>
                                </button>

                                <button mat-icon-button color="accent" title="Assinar"
                                    *ngIf="checkProfessional(document.performer?.id)"
                                    [disabled]="isButtonDisabled || signingDocument"
                                    (click)="signDocumentToList($event, document)">
                                    <img class="action-sign-icon" src="assets/icons/signature.svg" alt="sign">
                                </button>
                            </div>
                        </mat-expansion-panel-header>

                        <div class="pdf-container history-document-preview">
                            <ngx-extended-pdf-viewer
                                *ngIf="(document.format == 'docx' || document.format == 'rtf') && selectedIndex == i && pdfSrc != null"
                                [src]="pdfSrc" [showHandToolButton]="true" [handTool]="false"
                                [contextMenuAllowed]="false" [showSidebarButton]="false"
                                [showUnverifiedSignatures]="false" height="50vh" [zoom]="zoom">
                            </ngx-extended-pdf-viewer>

                            <quill-editor *ngIf="document.format == 'html' || document.format == 'txt'" #quill fxFlex
                                class="history-quill-viewer" [modules]="{ toolbar: [] }" format="html"
                                [ngStyle]="{ 'height.px': getHeight() }" [ngModel]="result" [readOnly]="true">
                            </quill-editor>

                        </div>

                    </mat-expansion-panel>
                </mat-accordion>

                <mat-paginator #paginator showFirstLastButtons stickyEnd [length]="totalElements" [pageIndex]="pagina"
                    [pageSizeOptions]="[5]" (page)="getDocuments($event,'page')"></mat-paginator>
            </div>
        </div> <!-- end right-panel -->

        <!-- PDF HISTORY PANEL (when pdfHistory true) -->
        <div *ngIf="!toggleHistory && pdfHistory" fxFlex="1 1 100%" fxFlex.gt-sm="50%" fxLayout="column"
            class="pdf-history-panel" style="min-height: 0;">
            <div fxHide.gt-sm fxLayout="row" fxLayoutAlign="space-between center" class="history-mobile-header">
                <span>Histórico completo</span>

                <button mat-icon-button (click)="returnToAnamnese()" title="Voltar para anamnese" color="accent">
                    <mat-icon>arrow_back</mat-icon>
                </button>
            </div>

            <div class="content" *ngIf="loading" fxLayoutAlign="center center">
                <mat-spinner></mat-spinner>
            </div>

            <mat-form-field *ngIf="!loading" appearance="outline">
                <mat-label>Selecione um periodo</mat-label>
                <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                    <input matStartDate formControlName="start" placeholder="Data Inicial">
                    <input matEndDate formControlName="end" placeholder="Data Final">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>

            <ngx-extended-pdf-viewer *ngIf="!loading && pdfHistorySrcFHD" [src]="pdfHistorySrcFHD"
                [showUnverifiedSignatures]="false" [showHandToolButton]="true" [handTool]="false"
                [contextMenuAllowed]="false" [showSidebarButton]="false" [zoom]="zoom">
            </ngx-extended-pdf-viewer>
        </div>

    </div> <!-- end content-area -->
</div>
